module.exports = __webpack_public_path__ + "static/media/curIndFormacion.6c555d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curIndFormacion.png
// module id = 973
// module chunks = 0